module.exports = __webpack_public_path__ + "img/trees-silhouette-2.89c86057.png";